import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ApprovalUnifiedEventNote(props) {
  const {
    event
  } = props;
  if (!event.properties.hs_note || !event.properties.hs_note.value) {
    return null;
  }
  return /*#__PURE__*/_jsx(UITile, {
    className: "m-top-2",
    compact: true,
    children: /*#__PURE__*/_jsx(UITileSection, {
      children: event.properties.hs_note.value
    })
  });
}